(function (window) {
  if (window.Modal) {
    return window.Modal;
  }

  const container = document.createElement('div');
  container.setAttribute('id', 'modal-container');
  document.body.appendChild(container);

  const vm = new Vue({
    el: '#modal-container',
    data: {
      content: null,
      isOpen: false,
      canClose: true,
      modalOptions: {},
      currentModalComponent: null,
      promiseResolve: (data) => data,
      promiseReject: (data) => data,
      modalClassName: '',
      modals: {
        JOGO: () => import('./_ModalJogo.vue'),
        FORM_FILTER: () => import('./_ModalFormFilter.vue'),
        CONFIRMED_WITHDRAWAL: () => import('./_ModalConfirmedWithdrawal.vue'),
        ANTECIPACAO: () => import('./_ModalAntecipacao.vue'),
        REDO_GAME: () => import('./_ModalRedoGame.vue'),
        PAY_AME_DIGITAL: () => import('./_ModalAmeDigital.vue'),
        GAME_WARNING: () => import('./_ModalGameWarning.vue'),
        DELETE_ACCOUNT: () => import('./_ModalDeleteAccount.vue'),
        PAYMENT_CONFIRMATION: () => import('./_ModalPaymentConfirmation.vue'),
        COMPROVANTE_TELESENA: () => import('./_ModalComprovanteTeleSena.vue'),
        POLITICA_PRIVACIDADE_TELESENA: () => import('./_ModalPoliticaPrivacidadeTeleSena.vue'),
        STOP_AUTOMATIC_RECURRENCE: () => import('./_ModalStopAutomaticRecurrence.vue'),
        REDO_RECURRENCE: () => import('./_ModalRedoRecurrence.vue'),
        RECURRENCE_WARNING: () => import('./_ModalRecurrenceWarning.vue'),
        FORGOT_ACCESS: () => import('./_ModalForgotAccess.vue'),
        RESET_PASSWORD: () => import('./_ModalResetPassword.vue'),
        RESET_SOCIAL_PASSWORD: () => import('./_ModalResetPasswordSocial.vue'),
        PICPAY_DIGITAL: () => import('./_ModalPicPayDigital.vue'),
        IUGU_LIMIT_WARNING: () => import('./_ModalIuguLimitWarning.vue'),
        GUESS_TESTER: () => import('./_ModalGuessTester.vue'),
        RECURRENCE_SPECIAL_WARNING: () => import('./_ModalRecurrenceSpecialWarning.vue'),
        COMPLETE_REGISTRATION: () => import('./_ModalCompleteRegistration.vue'),
        BLACK_FRIDAY_WARNING: () => import('./_ModalBlackFridayWarning.vue'),
        TERMS_CONDITIONS: () => import('./_ModalTermsAndConditions.vue')
      }
    },
    template: `
      <div v-if="isOpen" @keydown.esc="close">
        <div class="modal" v-bind:class="['modal--'+modalClassName]">
          <div class="modal-box">
          <button v-if="canClose" class="modal-box__button-close" v-on:click="close()"><i class="fa fa-close"></i></button>
            <component v-bind:is="currentModalComponent" :options="modalOptions" v-on:close="close"></component>
          </div>
          <div class="modal-shadow" v-on:click="close()"></div>
        </div>
      </div>
    `,
    methods: {
      open: function (modalName, options, canClose = true) {
        return new Promise((resolve, reject) => {
          this.promiseResolve = resolve;
          this.promiseReject = reject;
          const modal = this.modals[modalName];

          if (!modal) {
            console.error(
              `Error: "${modalName}" isn't a valid modal. Try one of these: ${Object.keys(
                this.modals
              ).join(', ')}`
            );
            return;
          }

          this.isOpen = true;
          this.currentModalComponent = null;
          this.canClose = canClose;

          this.modalClassName = (modalName || '')
            .toLowerCase()
            .replace(/_/g, '-');

          this.modalOptions = options || {};
          this.currentModalComponent = modal || null;
          const body = document.querySelector('body');
          body.classList.add('is-modal-active');
        })
      },
      close: function (data = null, force = false) {
        if (!this.canClose && !force) {
          return;
        }

        this.container = null;
        this.isOpen = false;
        this.modalOptions = {};
        this.canClose = true;
        const body = document.querySelector('body');
        body.classList.remove('is-modal-active');
        this.promiseResolve(data)
      }
    }
  });

  const _public = {
    open: vm.open,
    close: vm.close
  };

  window.Modal = _public;
})(window);

export default window.Modal;
